export enum OperationState {
    Auto = 0, // Auto
    Off = 1, // Off
    On = 2,  //On, Step1, Open
    Step2 = 3, // Step2, Close
    Step3 = 4, // Step 3
    Step4 = 5, // Step 4
    Step5 = 6, // Step 5
  }